
import { ISize, LogGroup, Size } from "../MyHelpers";
import { PixiSpriteResource } from "../ResourceManager/PixiSpriteResource";
import { Resourceful } from "../ResourceManager/Resourceful";
import { ResourceIdentifier } from "../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "../ResourceManager/ResourceManager";
import { Translator } from "../Translator";
import { CanvasSprite } from "./Sprite/CanvasSprite";
import { service } from "../services";
import { MyCanvas } from "./MyCanvas";
import { Sprite } from "./Sprite/Sprite";
import { ISprite } from "./Sprite/ISprite";

export interface ITranslatedCanvasParams {
    path: string,
    resid: ResourceIdentifier,
    //gameName: string, 
    logGroup: LogGroup,
    viewSize: ISize,
    nameSpriteSlide: string,
    translator: Translator,
}

export class TranslatedCanvasSprite implements Resourceful {
    protected pathSprite: string;
    protected resid: ResourceIdentifier;
    protected gameName: string;
    protected logGroup: LogGroup;
    protected canvasSprite: CanvasSprite;
    protected viewSize: ISize;
    protected nameSlideSprite: string;
    protected translator: Translator;
    protected spritePixie: Sprite[] = [];
    protected languagesSprite: Map<string, ISprite> = new Map<string, ISprite>();


    constructor(params: ITranslatedCanvasParams) {
        this.pathSprite = params.path;
        this.resid = params.resid;
        //this.gameName = params.gameName;
        this.logGroup = params.logGroup;
        this.viewSize = params.viewSize;
        this.nameSlideSprite = params.nameSpriteSlide;
        this.translator = params.translator;

    }

    public PrepareResources(resourceManager: IWriteOnlyResourceManager) {
        //console.log("languages:" + service.translator.availableLanguages);
        for (let lang of this.translator.availableLanguages) {
            resourceManager.Add(new PixiSpriteResource(this.pathSprite +"_"+lang.localityShort, this.resid.Add(this.nameSlideSprite +"-"+ lang.localityShort), true, this.logGroup.Add(this.nameSlideSprite), true));
        }
    }

    public ResourcesLoaded(resourceManager: IReadOnlyResourceManager) {
        for (let lang of this.translator.availableLanguages) {
            let sprite = resourceManager.Get<PixiSpriteResource>(this.resid.Add(this.nameSlideSprite +"-"+ lang.localityShort)).sprite.Copy();
            this.languagesSprite.set(lang.localityShort, sprite);
        }
        this.canvasSprite = new CanvasSprite({sprite: this.languagesSprite.get(this.translator.t.localityShort), canvasSize: new Size(this.viewSize.Width, this.viewSize.Height)});
        this.translator.SetOnLanguageChangedCallback(() => {
            let currentLanguage = this.translator.t.localityShort;
            this.canvasSprite.ChangeSprite(this.languagesSprite.get(currentLanguage));
            this.canvasSprite.Update(true);
        });
    }

    public View(): HTMLElement {
        return this.canvasSprite.View();
    }

    public Update() {
        this.canvasSprite.Update();
    }

    public Start() {
        this.canvasSprite.Start(false);
    }

    public Stop() {
        this.canvasSprite.StopAndReset()
    }
}
